import Vue from "vue";
import { Pagination, Button } from "ant-design-vue";
Vue.component(Pagination.name, Pagination);
Vue.component(Button.name, Button);
